<template>
  <section class="my-5">

    <div class="form-content">
      <h3>マナビス・ショッピングクラブ会員登録手続き完了のお知らせ</h3>
      <p class="my-5">真奈 美須子 様</p>
      <p class="my-5">この度は、マナビス・ショッピングクラブ会員登録にお申込みいただき、誠にありがとうございます。</p>
      <p class="my-5">ショッピングクラブ会員登録手続き終了後、ご注文の商品を発送させていただきます。<br>
      配送状況により商品の配達に数日かかる場合がございます。今しばらくお待ちいただけますと幸いです。<br>
      登録申込時にご注文いただいた商品を受け取られるまでは、新たな注文はお受けできません。あらかじめご了承ください。</p>
      <p class="my-5">なお、ご注文の際は会員番号とパスワードが必要となります。<br>
      ご注文は以下の URL からログインをしてください。</p>
      <p class="my-5"><a href="https://www.manavis-cosme.co.jp/web/#/login">https://www.manavis-cosme.co.jp/web/#/login</a></p>
      <p class="my-5">
        ------------------------------------------------------------------------------------------<br>
        <br>
        ◇申込者情報◇<br>
        <br>
        ------------------------------------------------------------------------------------------
      </p>
      <p class="my-5">
        メールアドレス：info@manavis-cosme.co.jp<br>
        氏名：真奈&emsp;美須子<br>
        氏名<span class="fs-08">（フリガナ）</span>：マナ&emsp;ビスコ<br>
        性別：女性<br>
        配偶者：無し<br>
        生年月日：0000/00/00<br>
        郵便番号：2790032<br>
        住所：千葉県浦安市千鳥15-9<br>
        住所<span class="fs-08">（フリガナ）</span>：チバケンウラヤスシチドリ15バンチ8<br>
        住所<span class="fs-08">（建物名）</span>：マナビスマンション101<br>
        住所<span class="fs-08">（その他）</span>：浦安舞子方<br>
        配送時連絡先：携帯電話番号<br>
        携帯電話番号：0888888888<br>
        自宅電話番号：<br>
        FAX番号：<br>
        当社からの広告等のメール・SMS・FAX送信：承諾しない
      </p>
      
      <p class="my-5">※パスワードがご不明の場合は、お問い合わせ窓口までご連絡ください。</p>

      <p class="my-5">
        ------------------------------------------------------------------------------------------<br>
        <br>
        ◇商品ご注文内容◇<br>
        <br>
        ------------------------------------------------------------------------------------------
      </p>
      <p class="my-5">
        ■送付先<br>
        〒279-0032<br>
        千葉県浦安市千鳥15-9<br>
        浦安&emsp;舞子&emsp;様
        <br>
        配送希望日：2022/00/00<br>
        配送希望時間帯：指定なし<br>
        <br>
        ■購入商品<br>
        薬用スキンウォッシュ<br>
        ￥5,250（税込み）<br>
        個数：1個<br>
        ----------<br>
        フローラ&emsp;ファーストセラム<br>
        ￥7,350（税込み）<br>
        個数：1個<br>
        ----------<br>
        <br>
        代引手数料：￥0<br>
        送料：￥0<br>
        合計金額：￥12,600<br>
        （内消費税：￥1,147）<br>   
      </p>
      <p class="my-5">
        ------------------------------------------------------------------------------------------<br>
        ※本メールは、配信専用のアドレスで配信されているため、返信いただいても返答いたしかねますのであらかじめご了承ください。<br>
        ※本メールの内容についてのお問い合わせは、下記のお問い合わせ窓口まで連絡をお願いいたします。<br>
        <br>
        株式会社マナビス化粧品お問い合わせ窓口<br>
        メール <a href="mailto:mc-info@manavis-cosme.co.jp">mc-info@manavis-cosme.co.jp</a><br>
        ------------------------------------------------------------------------------------------
      </p>
    </div>
  </section>
</template>
<script>

export default {
  mounted() {
    window.scroll(0, 0);
  }
};

</script>
